import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react'

export default function CaretDownIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.5 9 12 16.5 4.5 9" stroke="currentColor" strokeWidth="1.546" strokeLinecap="round" strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
